import {texture} from "p3";
import common from "../../common";
import definitions from "../../definitions";
import GameScene from "../../scenes/GameScene";

export default class Compass extends PIXI.Container {
    constructor() {
        super();

        this._needle = null;
        this._dial = null;
        this._cover = null;
        this._targets = [];
        this._animatingIntro = false;
        this._needleTimer = {current:0, max:5};

        this.init();
    }

    init() {

        this._container = new PIXI.Container();
        this.addChild(this._container);

        this._dial = new PIXI.Sprite(texture("compass_on"));
        this._dial.anchor.set(0.5);
        this._container.addChild(this._dial);

        this._needle = new PIXI.Sprite(texture("compass_arrow_01"));
        this._needle.anchor.set(0.5);
        this._needle.y = 10;
        this._container.addChild(this._needle);

        this._cover = new PIXI.Sprite(texture("compass_off"));
        this._cover.anchor.set(0.5);
        this._container.addChild(this._cover);

        this._container.position.set(this._dial.width/2, this._dial.height/2);
    }

    update() {
        if (this._targets.length > 0 && !this._animatingIntro){
            const closest = this._getClosestTarget();
            this._needle.rotation += ((closest.vector.angle - (PIXI.DEG_TO_RAD * 90)) - this._needle.rotation) * 0.25;
            const closeRange = closest.vector.length < 1000;
            if (this._needleTimer.current >= this._needleTimer.max * (closeRange ? 0.3 : 1)) {
                this._animatePulse(closeRange);
            }
            this._needleTimer.current += window.dt;
        }
    }

    reset(targets) {
       // console.log('TARGETS', targets);
        
        this._cover.visible = targets.length == 0;

        if (targets.length > 0) {
            this._targets = targets;
            this._animateIntro();
        } else {
            this._animateClose(this._targets.length > 0);
            this._targets = targets;
        }
    }

    _getClosestTarget() {
        let closest = this._targets[0];
        if (this._targets.length > 1) {
            for (let i in this._targets) {
                if (this._targets[i].vector.length < closest.vector.length) {
                    closest = this._targets[i];
                }
            }
        }
        return closest;
    }

    _animateIntro() {
        this.scale.set(1);
        this._animatingIntro = true;
        const angle = this._getClosestTarget().vector.angle;
        GameScene.active.addTween(
            gsap.to(this._needle, 3, {rotation:(1080 + ((angle * PIXI.RAD_TO_DEG) - 90)) * PIXI.DEG_TO_RAD, ease:Sine.easeOut, onComplete:() => {
                this._needle.rotation = angle - (PIXI.DEG_TO_RAD * 90);
                this._animatingIntro = false;
                this._animatePulse(false);
            }}),
            gsap.to(this._container.scale, 0.3, {x:1.2, y:1.2, yoyo:true, repeat:7, ease:Sine.easeInOut})
        )
    }

    _animatePulse(closeRange = false) {
        this._needle.scale.set(1);
        GameScene.active.addTween(
            gsap.to(this._needle.scale, closeRange ? 0.1 : 0.2, {y:0.8, yoyo:true, repeat:closeRange ? 11 : 5, ease:Sine.easeInOut})
        );
        if (closeRange) {
            this._container.scale.set(1);
            gsap.to(this._container.scale, 0.3, {x:1.2, y:1.2, yoyo:true, repeat:3, ease:Sine.easeInOut})
        }
        this._needleTimer.current = 0;
    }

    _animateClose(animate = false) {
        const inactiveScale = 0.75;
        if (animate) {
            this.scale.set(inactiveScale);
        } else {
            GameScene.active.addTween(
                gsap.to(this.scale, 0.4, {x:inactiveScale, y:inactiveScale, ease:Sine.easeInOut})
            );
        }
    }
}